__turbopack_context__.v({
  "chevron": "select-module-scss-module__th0PVq__chevron",
  "dropdown": "select-module-scss-module__th0PVq__dropdown",
  "field": "select-module-scss-module__th0PVq__field",
  "filterChevron": "select-module-scss-module__th0PVq__filterChevron",
  "filterClearButton": "select-module-scss-module__th0PVq__filterClearButton",
  "filterDropdown": "select-module-scss-module__th0PVq__filterDropdown",
  "filterField": "select-module-scss-module__th0PVq__filterField",
  "filterInput": "select-module-scss-module__th0PVq__filterInput",
  "filterOption": "select-module-scss-module__th0PVq__filterOption",
  "filterOptions": "select-module-scss-module__th0PVq__filterOptions",
  "filterRoot": "select-module-scss-module__th0PVq__filterRoot",
  "filterScrollAreaContent": "select-module-scss-module__th0PVq__filterScrollAreaContent",
  "filterSection": "select-module-scss-module__th0PVq__filterSection",
  "filterStretch": "select-module-scss-module__th0PVq__filterStretch",
  "filterWrapper": "select-module-scss-module__th0PVq__filterWrapper",
  "input": "select-module-scss-module__th0PVq__input",
  "option": "select-module-scss-module__th0PVq__option",
  "options": "select-module-scss-module__th0PVq__options",
  "root": "select-module-scss-module__th0PVq__root",
  "scrollAreaContent": "select-module-scss-module__th0PVq__scrollAreaContent",
  "sized": "select-module-scss-module__th0PVq__sized",
  "wrapper": "select-module-scss-module__th0PVq__wrapper",
});
